import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@store/utils';

interface MailingData {
  name?: string;
  email: string;
  category: TCategoryType;
}
interface BugReportData {
  title: string;
  message: string;
}

export type TCategoryType =
  | 'individual'
  | 'business'
  | 'insurance agent or broker'
  | 'insurer or reinsurer'
  | 'investor';

export const mailingApi = createApi({
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    sendMailingInfo: builder.mutation<any, MailingData>({
      query: (payload: MailingData) => ({
        url: `coverage/explore_risk/`,
        method: 'POST',
        body: payload,
      }),
    }),
    sendBugReport: builder.mutation<any, BugReportData>({
      query: (payload: BugReportData) => ({
        url: `bug_report/`,
        method: 'POST',
        body: payload,
      }),
    }),
    sendQuoteToPurchaser: builder.mutation<any, { token: string }>({
      query: (payload: { token: string }) => ({
        url: `share_plan_quote/`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const {
  useSendMailingInfoMutation,
  useSendBugReportMutation,
  useSendQuoteToPurchaserMutation,
} = mailingApi;
